import styles from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/Components/ViewportToggler/ViewportToggler.css';
import script from '/builds/sitegeist/bad-toelz-de/.build/releases/1/DistributionPackages/BadToelz.BadToelzDe/Resources/Private/Fusion/Presentation/Components/ViewportToggler/ViewportToggler.ts';

export const prototypeName = 'onjWLPr2X9hpedLv4RDwfbrnn3eGXMFXWMPMXxyMcn4LxPznOXiVXvG84GNPS96wDP2RAvcKpO6A0';
export {styles};
export {script};